import React from "react";

export default function CardsBlock({ data }) {
  const cards = data.items || [
    { title: "Card Title", description: "Card description" },
  ];

  return (
    <div style={{ marginTop: "20px" }}>
      <h2 style={{ color: "white" }}>{data.title || "Cards Section"}</h2>

      <div style={{ display: "flex", gap: "20px", marginTop: "15px" }}>
        {cards.map((card, i) => (
          <div
            key={i}
            style={{
              padding: "20px",
              background: "#222",
              borderRadius: "12px",
              width: "220px",
              color: "white",
            }}
          >
            <h3>{card.title}</h3>
            <p style={{ opacity: 0.8 }}>{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
